enum EmployeeGroupStatusEnum {
  Unknown = "unknown",
  Created = "created",
  Activated = "activated",
}

export { EmployeeGroupStatusEnum };
